import { Popover as BasePopover } from '@base-ui/react/popover';
import styled from '@emotion/styled';

import { scrollbarStyles } from '../../scrollbar';
import { shadows } from '../../shadows';
import { spacing } from '../../spacing';

const forwardProp = (prop: string) => !prop.startsWith('$');

export const StyledPositioner = styled(BasePopover.Positioner)({
  zIndex: 1400,
});

export const StyledPopup = styled(BasePopover.Popup, { shouldForwardProp: forwardProp })<{
  $maxWidth?: number;
  $maxHeight?: number | string;
}>(({ theme, $maxWidth, $maxHeight }) => ({
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  maxWidth: $maxWidth,
  maxHeight: $maxHeight,
  padding: spacing[16],
  gap: spacing[8],
  borderRadius: theme.radius[8],
  border: `1px solid ${theme.colors.border.default}`,
  backgroundColor: theme.colors.background.raised,
  boxShadow: shadows.md,
  outline: 'none',
  // Base UI sets this custom property to the anchor-relative side/align so the
  // scale-in animation grows from the edge nearest the anchor, even after a flip.
  transformOrigin: 'var(--transform-origin)',
  transition: 'opacity 150ms ease, transform 150ms ease',

  '&[data-starting-style], &[data-ending-style]': {
    opacity: 0,
    transform: 'scale(0.97)',
  },
}));

export const TitleRow = styled('div')({
  width: '100%',
  display: 'flex',
  alignItems: 'flex-start',
  gap: spacing[8],
});

export const PopupContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  boxSizing: 'border-box',
  overflowY: 'auto',
  flex: 1,
  minHeight: 0,
  padding: 4,
  margin: -4,
  width: 'calc(100% + 8px)',
  ...scrollbarStyles,
});
